import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LegacyRedirect = (): null => {
  const navigate = useNavigate();

  useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const currentPath = currentUrl.pathname;
    if (currentPath.includes('/hc/en-us')) {
      const newPath = currentPath.replace('/hc/en-us', '');
      navigate(newPath, { replace: true });
    }
  }, []);

  return null;
};

export default LegacyRedirect;
